import * as fgts from '@/api/fgts'

const state = {
  dados: []
}

const getters = {}

const mutations = {
  SET (state, payload) {
    state.dados = payload
  }
}

const actions = {
  async get (context, registro) {
    let data = await fgts.get(registro)
    let instancia = data.instancia
    if (instancia) {
      let item = {
        identificacao: 'consignado_fgts',
        nome: 'Consignado FGTS'
      }
      context.dispatch('pedido/setFGTS', item, { root: true })
      context.commit('SET', instancia)
    } else {
      context.dispatch('pedido/setFGTS', false, { root: true })
      context.commit('SET', false)
    }
    return []
  },
  async clear (context) {
    context.dispatch('pedido/setFGTS', false, { root: true })
    context.commit('SET', false)
  }
}

export default { namespaced: true, state, getters, mutations, actions }



// WEBPACK FOOTER //
// ./src/store/modules/pedido/fgts.js